<template>
    <div class='of-container'>
        <of-content-1 class="of-content" :view="ofPage.content1"></of-content-1>
        <of-content-2 class="of-content" :view="ofPage.content2"></of-content-2>
        <of-content-5 class="of-content" :view="ofPage.content9" style="margin-top: 2.7em!important;"></of-content-5> <!-- content9 -->
        <of-content-10 class="of-content" :view="ofPage.content10"></of-content-10>
        <of-content-3 class="of-content" :view="ofPage.content3" :userTest="this.view.user"></of-content-3>
        <of-content-4 class="of-content" :view="ofPage.content4" :userTest="this.view.user"></of-content-4>
        <of-content-5 class="of-content" :view="ofPage.content5"></of-content-5>
        <!-- <of-content-6 class="of-content" :view="ofPage.content6"></of-content-6> --> <!-- esconder por enquanto -->
        <of-content-7 class="of-content" :view="ofPage.content7"></of-content-7>

        <of-content-5 class="of-content" :view="ofPage.content8"></of-content-5> <!-- content8 -->
    </div>
</template>


<script>
import lodash from 'lodash';

export default {

    name: "office-onboarding-funnel",
    props: ["view"],
    components: {
    },

    data() {
        return {
            showConnectDomain: false,
            content1: {
                description: {
                    title: "Dashboard Funnel Club",
                    text: 'Auctor aliquam ut quam nibh consequat sociosqu senectus condimentum feugiat. Nunc facilisis auctor donec etiam mauris laoreet. Nunc sollicitudin nostra vestibulum. Quisque sodales purus amet nostra mattis eget placerat vehicula vulputate. Interdum leo inceptos lectus imperdiet vehicula ultrices sit.'
                },
                socialMedia: {
                    mainSvg: '/internacional/public/office4/img/onboarding-funnel/content-1/ic-social-media-card.svg',
                    title: 'Join Community',
                    text: 'Auctor aliquam ut quam nibh consequat sociosqu senectus condimentum feugiat.',
                    'url_socials': { /* nao colocar no translation na view php, vem de outro lugar */
                        facebook: {
                            title: 'titulo facebook',
                            text: 'texto facebook',
                            link: 'https://www.facebook.com/'
                        },
                        instagram: {
                            title: 'titulo instagram',
                            text: 'texto instagram',
                            link: 'https://www.instagram.com/'
                        },
                        twitter: {
                            title: 'titulo twitter',
                            text: 'texto twitter',
                            link: 'https://twitter.com/'
                        },
                        youtube: {
                            title: 'titulo youtube',
                            text: 'texto youtube',
                            link: 'https://www.youtube.com/'
                        }
                    },
                    socialMediaSvg: {
                        facebook: '/internacional/public/office4/img/onboarding-funnel/content-1/ic-facebook.svg',
                        instagram: '/internacional/public/office4/img/onboarding-funnel/content-1/ic-instagram.svg',
                        twitter: '/internacional/public/office4/img/onboarding-funnel/content-1/ic-twitter.svg',
                        youtube: '/internacional/public/office4/img/onboarding-funnel/content-1/ic-youtube.svg'
                    }
                },
                tutorial: {
                    mainSvg: '/internacional/public/office4/img/onboarding-funnel/content-1/ic-youtube-tutorial.svg',
                    title: 'Tutorial',
                    text: 'Auctor aliquam ut quam nibh consequat sociosqu senectus condimentum feugiat.',
                    button: {
                        text: "Learn more",
                        link: "#"
                    }
                }
            },
            content2: {
                title: '&ldquo;You have never seen anything like what we are bringing to the marketplace&rdquo;',
                name: 'Erick Salgado',
                occupation: 'Builderall CEO / Founder',
                mainSvg: "/internacional/public/office4/img/onboarding-funnel/content-2/CEO.svg",
                video: "https://videomng.builderall.com/embed/NSG8aNMz2L?autoplay=2&countdown=1&controls=1&allowpause=1",
                affiliate: {
                    text: 'Your Funnel Club Affiliate Link:',
                    link: 'https://builderall.affiliados/978752',
                    button: 'copy'
                },
                baIntelligenceTag: 'fc-c2-copy-affiliate-link'
            },
            content3: {
                cards: [
                    { /* card1 */
                        content: [
                            { /* item1 */
                                type: 'topper',
                                mainSvg: '/internacional/public/office4/img/onboarding-funnel/content-3/ic-mobile-topper.svg',
                                title: 'Funnels',
                                text: 'Aptent varius a velit dictum convallis cursus nam ullamcorper. Aliquet tellus per quisque. Feugiat nibh eleifend fusce inceptos nulla tellus quis sem.'
                            },
                            { /* item2 */
                                type: 'item-right',
                                mainSvg: '/internacional/public/office4/img/onboarding-funnel/content-3/ic-premium-funnel.svg',
                                title: {
                                    text: 'Builderall Premium Funnels',
                                    color: '#B07EFF' // color1
                                },
                                text: 'Affiliate funnels that are optimized for conversions. When you use the affiliate link for these funnels, they are designed to bring in new Builderall members with you as their sponsor. You can also brand the affiliate link with your own domain.',
                                button: {
                                    text: 'Learn more',
                                    link: '#'
                                },
                                baIntelligenceTag: 'fc-c3-builderall-premium-funnels-us-id'
                            },
                            { /* item3 */
                                type: 'item-right',
                                mainSvg: '/internacional/public/office4/img/onboarding-funnel/content-3/ic-niche-funnels.svg',
                                title: {
                                    text: 'Niche Funnels',
                                    color: '#017AF7' // color2
                                },
                                text: 'Affiliate funnels designed to give to business owners so they can setup a free account with Builderall and start collecting their own leads.',
                                button: {
                                    text: 'Learn more',
                                    link: '#'
                                },
                                baIntelligenceTag: 'fc-c3-niche-funnels-us-id'
                            },
                            { /* item4 */
                                type: 'item-right',
                                mainSvg: '/internacional/public/office4/img/onboarding-funnel/content-3/ic-leads-capture-funnels.svg',
                                title: {
                                    text: 'Leads Capture Funnels',
                                    color: '#002D92' // color3
                                },
                                text: 'Funnels designed to capture leads for your own subscriber list. These funnels are professionally designed for optin conversions and include the lead magnet in the funnel.',
                                button: {
                                    text: 'Learn more',
                                    link: '#'
                                },
                                baIntelligenceTag: 'fc-c3-lead-capture-funnels-us-id'
                            },
                        ],
                        halfMoonUpPath: '/internacional/public/office4/img/onboarding-funnel/content-3/ic-half-moon.svg',
                        halfMoonDownPath: '/internacional/public/office4/img/onboarding-funnel/content-3/ic-half-moon.svg'
                    },

                    { /* card2 */
                        content: [
                            { /* item1 */
                                type: 'item-left',
                                mainSvg: '/internacional/public/office4/img/onboarding-funnel/content-3/ic-agency-funnels.svg',
                                title: {
                                    text: 'Agency Funnels',
                                    color: '#FFBE4B' // color4
                                },
                                text: 'Niche funnels templates in specific business areas that are designed for you to use as an website development agency to provide services to your own client.',
                                button: {
                                    text: 'Learn more',
                                    link: '#'
                                },
                                baIntelligenceTag: 'fc-c3-agency-funnels-us-id'
                            },
                            { /* item2 */
                                type: 'item-left',
                                mainSvg: '/internacional/public/office4/img/onboarding-funnel/content-3/ic-chatbot-funnels.svg',
                                title: {
                                    text: 'Chatbot Funnels',
                                    color: '#470AC8' // color5
                                },
                                text: 'Meet Chat Marketing! Automate & Combine Facebook Messenger and SMS to Grow Your Business Sell products, book appointments, nurture leads, capture contact info, and build relationships all through the Builderall Messenger Chatbot.',
                                button: {
                                    text: 'Learn more',
                                    link: '#'
                                },
                                baIntelligenceTag: 'fc-c3-chatbot-funnels-us-id'
                            },
                            { /* item3 */
                                type: 'item-left',
                                mainSvg: '/internacional/public/office4/img/onboarding-funnel/content-3/ic-info-product-funnels.svg',
                                title: {
                                    text: 'Info Product Funnels',
                                    color: '#00e1d6' // color7
                                },
                                text: 'Info Product Funnels',
                                button: {
                                    text: 'Learn more',
                                    link: '#'
                                },
                                baIntelligenceTag: 'fc-c3-info-product-funnels-us-id'
                            },
                        ],
                        halfMoonUpPath: '/internacional/public/office4/img/onboarding-funnel/content-3/ic-half-moon.svg',
                        halfMoonDownPath: '/internacional/public/office4/img/onboarding-funnel/content-3/ic-half-moon.svg'
                    },
                    { /* card3 */
                        content: [
                            { /* item4 */
                                type: 'item-right',
                                mainSvg: '/internacional/public/office4/img/onboarding-funnel/content-3/ic-physical-product-funnels.svg',
                                title: {
                                    text: 'Physical Product Funnels',
                                    color: '#03e18e' // color8
                                },
                                text: 'Physical Product Funnels',
                                button: {
                                    text: 'Learn more',
                                    link: '#'
                                },
                                baIntelligenceTag: 'fc-c3-physical-product-funnels-us-id'
                            },
                            { /* item5 */
                                type: 'item-right',
                                mainSvg: '/internacional/public/office4/img/onboarding-funnel/content-3/ic-market-place-funnel.svg',
                                title: {
                                    text: 'Marketplace Funnels',
                                    color: '#3384fb' // color9
                                },
                                text: 'Marketplace Funnels',
                                button: {
                                    text: 'Learn more',
                                    link: '#'
                                },
                                baIntelligenceTag: 'fc-c3-marketplace-funnels-us-id'
                            },
                            { /* item6 */
                                type: 'item-left-larger',
                                mainSvg: '/internacional/public/office4/img/onboarding-funnel/content-3/ic-cheetah-funnel-builder.svg',
                                title: {
                                    text: 'Cheetah Funnel Builder',
                                    color: '#FF7166' // color6
                                },
                                text: 'Where all the magic happens when all of our fully integrated tools come together to give you the power to build impressive funnel blueprints and then, with a push of the button, create the entire site directly from the blueprint.',
                                button: {
                                    text: 'Learn more',
                                    link: '#'
                                },
                                baIntelligenceTag: 'fc-c3-cheetah-funnel-builder-us-id'
                            },
                        ],
                        halfMoonUpPath: '/internacional/public/office4/img/onboarding-funnel/content-3/ic-half-moon.svg',
                        halfMoonDownPath: '/internacional/public/office4/img/onboarding-funnel/content-3/ic-half-moon.svg'
                    },
                ]
            },
            content4: {
                topper: {
                    title1: '40+',
                    title2: 'Tools',
                    text: 'We Provide Every Other Tool You Will Ever Need To Explode Your Business Online!',
                    imgLeftPath: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-left.svg',
                    imgRightPath: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-right.svg'
                },
                trainings: [
                    /* linha 1 */
                    {
                        path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-cheetah-website-builder.svg',
                        path_new: '/internacional/public/office5/img/tools/default/builderall_builder.svg',
                        link: '#',
                        borderClass: 'border1',
                        borderClassV5: 'border5',
                        title: 'Cheetah Drag & Drop Website Builder',
                        baIntelligenceTag: 'fc-c4-cheetah-website-builder'
                    },
                    {
                        path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-builderall-canvas.svg',
                        path_new: '/internacional/public/office5/img/tools/default/canvas.svg',
                        link: '#',
                        borderClass: 'border2',
                        borderClassV5: 'border5',
                        title: 'Builderall canvas',
                        baIntelligenceTag: 'fc-c4-cheetah-builderall-canvas'
                    },
                    {
                        path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-mailing-boss.svg',
                        path_new: '/internacional/public/office5/img/tools/default/mailingboss.svg',
                        link: '#',
                        borderClass: 'border3',
                        borderClassV5: 'border5',
                        title: 'Mailing Boss',
                        baIntelligenceTag: 'fc-c4-mailing-boss'
                    },
                    {
                        path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-funnel-club.svg',
                        path_new: '/internacional/public/office5/img/tools/default/video_manager.svg',
                        link: '#',
                        borderClass: 'border4',
                        borderClassV5: 'border5',
                        title: 'Funnel Club',
                        baIntelligenceTag: 'fc-c4-funnel-club'
                    },

                    /* linha 2 */
                    {
                        path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-telegram.svg',
                        path_new: '/internacional/public/office5/img/tools/hover/telegram.svg',
                        link: '#',
                        borderClass: 'border1',
                        borderClassV5: 'border5',
                        title: 'Telegram',
                        baIntelligenceTag: 'fc-c4-telegram'
                    },
                    {
                        path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-dns-manager.svg',
                        path_new: '/internacional/public/office5/img/tools/default/dns_manager.svg',
                        link: '#',
                        borderClass: 'border2',
                        borderClassV5: 'border5',
                        title: 'DNS Manager',
                        baIntelligenceTag: 'fc-c4-dns-manager'
                    },
                    {
                        path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-builderall-booking.svg',
                        path_new: '/internacional/public/office5/img/tools/default/booking.svg',
                        link: '#',
                        borderClass: 'border3',
                        borderClassV5: 'border5',
                        title: 'Builderall Booking',
                        baIntelligenceTag: 'fc-c4-booking-builder'
                    },
                    {
                        path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-app-builder.svg',
                        path_new: '/internacional/public/office5/img/tools/default/app_builder.svg',
                        link: '#',
                        borderClass: 'border4',
                        borderClassV5: 'border5',
                        title: 'App builder',
                        baIntelligenceTag: 'fc-c4-app-builder'
                    },

                    /* linha 3 */
                    {
                        path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-builderall-magazine-builder.svg',
                        path_new: '/internacional/public/office5/img/tools/default/magazine_editor.svg',
                        link: '#',
                        borderClass: 'border1',
                        borderClassV5: 'border5',
                        title: 'Builderall Unlimited magazine builder',
                        baIntelligenceTag: 'fc-c4-magazine-builder'
                    },
                    {
                        path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-wp3-click-integration.svg',
                        path_new: '/internacional/public/office5/img/tools/default/wordpress_site.svg',
                        link: '#',
                        borderClass: 'border2',
                        borderClassV5: 'border5',
                        title: 'Wordpress 3-click integration',
                        baIntelligenceTag: 'fc-c4-wordpress-integration'
                    },
                    {
                        path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-ecommerce.svg',
                        path_new: '/internacional/public/office5/img/tools/default/ecommerce_builder.svg',
                        link: '#',
                        borderClass: 'border3',
                        borderClassV5: 'border5',
                        title: '',
                        baIntelligenceTag: 'fc-c4-ecommerce-magento'
                    },
                    {
                        path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-builderall-directory-builder.svg',
                        path_new: '/internacional/public/office5/img/tools/default/directory_builder.svg',
                        link: '#',
                        borderClass: 'border4',
                        borderClassV5: 'border5',
                        title: 'builderall directory builder',
                        baIntelligenceTag: 'fc-c4-directory-builder'
                    },

                    /* linha 4 */
                    {
                        path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-mockup-studio.svg',
                        path_new: '/internacional/public/office5/img/tools/default/mockup_studio.svg',
                        link: '#',
                        borderClass: 'border1',
                        borderClassV5: 'border5',
                        title: 'mockup studio',
                        baIntelligenceTag: 'fc-c4-mockup-studio'
                    },
                    {
                        path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-video-funnel-builder.svg',
                        path_new: '/internacional/public/office5/img/tools/default/video_funnel_creator.svg',
                        link: '#',
                        borderClass: 'border2',
                        borderClassV5: 'border5',
                        title: 'video funnel builder',
                        baIntelligenceTag: 'fc-c4-video-funnel-builder'
                    },
                    {
                        path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-video-tag-tool.svg',
                        path_new: '/internacional/public/office5/img/tools/default/videotag.svg',
                        link: '#',
                        borderClass: 'border3',
                        borderClassV5: 'border5',
                        title: 'video tag tool',
                        baIntelligenceTag: 'fc-c4-video-tag-tool'
                    },
                    {
                        path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-builderall-video-hosting.svg',
                        path_new: '/internacional/public/office5/img/tools/default/video_host.svg',
                        link: '#',
                        borderClass: 'border4',
                        borderClassV5: 'border5',
                        title: 'builderall video hosting',
                        baIntelligenceTag: 'fc-c4-video-hosting'
                    },

                    /* linha 5 */
                    {
                        path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-3d-photo-editor-studio.svg',
                        path_new: '/internacional/public/office5/img/tools/default/image_manager.svg',
                        link: '#',
                        borderClass: 'border1',
                        borderClassV5: 'border5',
                        title: '3d photo editor studio',
                        baIntelligenceTag: 'fc-c4-animated-vsl-video-builder'
                    },
                    {
                        path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-animate-vsl-video.svg',
                        path_new: '/internacional/public/office5/img/tools/default/floating_videos.svg',
                        link: '#',
                        borderClass: 'border2',
                        borderClassV5: 'border5',
                        title: 'animate vsl video',
                        baIntelligenceTag: 'fc-c4-transparent-floating-videos'
                    },
                    {
                        path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-browser-notification-app.svg',
                        path_new: '/internacional/public/office5/img/tools/default/browser_notifications.svg',
                        link: '#',
                        borderClass: 'border3',
                        borderClassV5: 'border5',
                        title: 'browser notification app',
                        baIntelligenceTag: 'fc-c4-browser-notifications'
                    },
                    {
                        path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-seo-on_report-app.svg',
                        path_new: '/internacional/public/office5/img/tools/default/ferramenta_SEO.svg',
                        link: '#',
                        borderClass: 'border4',
                        borderClassV5: 'border5',
                        title: 'seo on-report app',
                        baIntelligenceTag: 'fc-c4-page-seo-report'
                    },

                    /* linha 6 */
                    {
                        path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-click-map.svg',
                        path_new: '/internacional/public/office5/img/tools/default/new_clickmap.svg',
                        link: '#',
                        borderClass: 'border1',
                        borderClassV5: 'border5',
                        title: 'click map',
                        baIntelligenceTag: 'fc-c4-new-clickmap'
                    },
                    {
                        path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-social-autopost-app.svg',
                        path_new: '/internacional/public/office5/img/tools/default/autopost.svg',
                        link: '#',
                        borderClass: 'border2',
                        borderClassV5: 'border5',
                        title: 'social autopost app',
                        baIntelligenceTag: 'fc-c4-social-autopost-app'
                    },
                    {
                        path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-professional-messenger-chatbot.svg',
                        path_new: '/internacional/public/office5/img/tools/default/facebook_chatbot.svg',
                        link: '#',
                        borderClass: 'border3',
                        borderClassV5: 'border5',
                        title: 'professional messenger chatbot',
                        baIntelligenceTag: 'fc-c4-messenger-chatbot'
                    },
                    {
                        path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-share-locker.svg',
                        path_new: '/internacional/public/office5/img/tools/default/share_locker.svg',
                        link: '#',
                        borderClass: 'border4',
                        borderClassV5: 'border5',
                        title: 'share locker',
                        baIntelligenceTag: 'fc-c4-facebook-viral-share-locker'
                    },

                    /* linha 7 */
                    {
                        path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-new-chatbuilder.svg',
                        path_new: '/internacional/public/office5/img/tools/default/new_chat_builder.svg',
                        link: '#',
                        borderClass: 'border1',
                        borderClassV5: 'border5',
                        title: 'new chatbuilder',
                        baIntelligenceTag: 'fc-c4-script-generator-new-chat-builder'
                    },
                    {
                        path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-new-elearning.svg',
                        path_new: '/internacional/public/office5/img/tools/default/new_e_learning.svg',
                        link: '#',
                        borderClass: 'border2',
                        borderClassV5: 'border5',
                        title: 'new elearning',
                        baIntelligenceTag: 'fc-c4-elearning'
                    },
                    {
                        path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-script-generator.svg',
                        path_new: '/internacional/public/office5/img/tools/default/copywriting.svg',
                        link: '#',
                        borderClass: 'border3',
                        borderClassV5: 'border5',
                        title: 'script generator',
                        baIntelligenceTag: 'fc-c4-script-generator-copywriting'
                    },
                    {
                        path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-video-wrapper.svg',
                        path_new: '/internacional/public/office5/img/tools/default/video_wrapper.svg',
                        link: '#',
                        borderClass: 'border4',
                        borderClassV5: 'border5',
                        title: 'video wrapper',
                        baIntelligenceTag: 'fc-c4-video-wrapper'
                    },

                    /* linha 8 */
                    {
                        path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-instagram-autoresponder.svg',
                        path_new: '/internacional/public/office5/img/tools/default/instagram_autoresponder.svg',
                        link: '#',
                        borderClass: 'border1',
                        borderClassV5: 'border5',
                        title: 'instagram autoresponder',
                        baIntelligenceTag: 'fc-c4-instagram-autoresponder'
                    },
                    {
                        path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-sms-messaging.svg',
                        path_new: '/internacional/public/office5/img/tools/default/sms.svg',
                        link: '#',
                        borderClass: 'border2',
                        borderClassV5: 'border5',
                        title: 'sms messaging',
                        baIntelligenceTag: 'fc-c4-sms messaging'
                    },
                    {
                        path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-builderall-webinar-builder.svg',
                        path_new: '/internacional/public/office5/img/tools/default/new_webinar.svg',
                        link: '#',
                        borderClass: 'border3',
                        borderClassV5: 'border5',
                        title: 'builderall webinar builder',
                        baIntelligenceTag: 'fc-c4-webinar builder'
                    },
                    {
                        path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-va-access.svg',
                        path_new: '/internacional/public/office5/img/tools/default/virtual_assistant_menu.svg',
                        link: '#',
                        borderClass: 'border4',
                        borderClassV5: 'border5',
                        title: 'va acess',
                        baIntelligenceTag: 'fc-c4-va-access'
                    },

                    /* linha 9 */
                    {
                        path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-professional-email.svg',
                        path_new: '/internacional/public/office5/img/tools/default/emails_app.svg',
                        link: '#',
                        borderClass: 'border1',
                        borderClassV5: 'border5',
                        title: 'professional email',
                        baIntelligenceTag: 'fc-c4-professional-emails'
                    },
                    {
                        path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-professional-website-bot.svg',
                        path_new: '/internacional/public/office5/img/tools/default/sitebot.svg',
                        link: '#',
                        borderClass: 'border2',
                        borderClassV5: 'border5',
                        title: 'professional website bot',
                        baIntelligenceTag: 'fc-c4-website-chat-bot'
                    },
                    {
                        path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-crm.svg',
                        path_new: '/internacional/public/office5/img/tools/default/crm.svg',
                        link: '#',
                        borderClass: 'border3',
                        borderClassV5: 'border5',
                        title: 'crm',
                        baIntelligenceTag: 'fc-c4-crm'
                    },
                    {
                        path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-marketplace.svg',
                        path_new: '/internacional/public/office5/img/tools/default/ecommerce_builder.svg',
                        link: '#',
                        borderClass: 'border4',
                        borderClassV5: 'border5',
                        title: 'marketplace',
                        baIntelligenceTag: 'fc-c4-marketplace'
                    },

                    /* linha 10 */
                    {
                        path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-cheetah-funnel-builder.svg',
                        path_new: '/internacional/public/office5/img/tools/default/cheetah_funnel_builder.svg',
                        link: '#',
                        borderClass: 'border1',
                        borderClassV5: 'border5',
                        title: 'cheetah funnel builder',
                        baIntelligenceTag: 'fc-c4-funnel-builder'
                    },
                    {
                        path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-design-resource.svg',
                        path_new: '/internacional/public/office5/img/tools/default/design_resource_1.svg',
                        link: '#',
                        borderClass: 'border2',
                        borderClassV5: 'border5',
                        title: 'design resource',
                        baIntelligenceTag: 'fc-c4-design-resource'
                    },
                    {
                        path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-new-market-place.svg',
                        path_new: '/internacional/public/office5/img/tools/default/market_place.svg',
                        link: '#',
                        borderClass: 'border3',
                        borderClassV5: 'border5',
                        title: 'new market place',
                        baIntelligenceTag: 'fc-c4-supercheckout-intern'
                    },
                    {
                        path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-website-agency.svg',
                        path_new: '/internacional/public/office5/img/tools/default/website_agency.svg',
                        link: '#',
                        borderClass: 'border4',
                        borderClassV5: 'border5',
                        title: 'website agency',
                        baIntelligenceTag: 'fc-c4-website-agency'
                    },

                    /* linha 11 */
                    {
                        path: '/internacional/public/office4/img/onboarding-funnel/content-4/ic-new-social-proof-pop_up.svg',
                        path_new: '/internacional/public/office5/img/tools/default/new_social_proof.svg',
                        link: '#',
                        borderClass: 'border1',
                        borderClassV5: 'border5',
                        title: 'new social proof pop-up',
                        baIntelligenceTag: 'fc-c4-social-proof-pop-up'
                    }
                ]
            },
            content5: {
                topper: {
                    mainSvg: '/internacional/public/office4/img/onboarding-funnel/content-5/ic-training-topper.svg',
                    title: 'TRAINING BUILDERALL',
                    text: 'We Provide Every Other Tool You Will Ever Need To Explode Your Business Online!'
                },
                category: {
                    title: "CATEGORY",
                    items: [
                        { /* item1 */
                            mainSvg: '/internacional/public/office4/img/onboarding-funnel/content-5/ic-training-card.svg',
                            title: "Marketing Afiliados",
                            text: 'Auctor aliquam ut quam nibh consequat sociosqu senectus condimentum feugiat.',
                            button: {
                                text: "Learn more",
                                link: "#"
                            },
                            baIntelligenceTag: 'fc-c5-digital-marketing-for-local-businesses'
                        },
                        { /* item2 */
                            mainSvg: '/internacional/public/office4/img/onboarding-funnel/content-5/ic-training-card.svg',
                            title: "Marketing Afiliados",
                            text: 'Auctor aliquam ut quam nibh consequat sociosqu senectus condimentum feugiat.',
                            button: {
                                text: "Learn more",
                                link: "#"
                            },
                            baIntelligenceTag: 'fc-c5-digital-marketing-for-launches'
                        },
                        { /* item3 */
                            mainSvg: '/internacional/public/office4/img/onboarding-funnel/content-7/ic-training-card.svg',
                            title: "Marketing Afiliados",
                            text: 'Auctor aliquam ut quam nibh consequat sociosqu senectus condimentum feugiat.',
                            button: {
                                text: "Learn more",
                                link: "#"
                            },
                            baIntelligenceTag: 'fc-c5-digital-marketing-for-network-marketing'
                        }
                    ]
                }
            },
            content6: {
                mainSvg: '/internacional/public/office4/img/onboarding-funnel/content-6/ic-banner.png'
            },
            content7: {
                title: "CATEGORY",
                items: [
                    { /* item1 */
                        mainSvg: '/internacional/public/office4/img/onboarding-funnel/content-7/ic-training-card.svg',
                        title: "Marketing Afiliados",
                        text: 'Auctor aliquam ut quam nibh consequat sociosqu senectus condimentum feugiat.',
                        button: {
                            text: "Learn more",
                            link: "#"
                        },
                        baIntelligenceTag: 'fc-c7-digital-marketing-for-courses-and-info-products'
                    },
                    { /* item2 */
                        mainSvg: '/internacional/public/office4/img/onboarding-funnel/content-7/ic-training-card.svg',
                        title: "Marketing Afiliados",
                        text: 'Auctor aliquam ut quam nibh consequat sociosqu senectus condimentum feugiat.',
                        button: {
                            text: "Learn more",
                            link: "#"
                        },
                        baIntelligenceTag: 'fc-c7-digital-marketing-for-physical-products'
                    },
                    { /* item3 */
                        mainSvg: '/internacional/public/office4/img/onboarding-funnel/content-5/ic-training-card.svg',
                        title: "Marketing Afiliados",
                        text: 'Auctor aliquam ut quam nibh consequat sociosqu senectus condimentum feugiat.',
                        button: {
                            text: "Learn more",
                            link: "#"
                        },
                        baIntelligenceTag: 'fc-c7-facebook-ads-beginner'
                    }
                ]
            },
            content8: { /* alias to content5 */
                topper: {}, // hide
                category: {
                    title: "CATEGORY",
                    items: [
                        { /* item1 */
                            mainSvg: '/internacional/public/office4/img/onboarding-funnel/content-5/ic-training-card.svg',
                            title: "Marketing Afiliados",
                            text: 'Auctor aliquam ut quam nibh consequat sociosqu senectus condimentum feugiat.',
                            button: {
                                text: "Learn more",
                                link: "#"
                            },
                            baIntelligenceTag: 'fc-c8-email-marketing-mailingboss'
                        },
                        { /* item2 */
                            mainSvg: '/internacional/public/office4/img/onboarding-funnel/content-5/ic-training-card.svg',
                            title: "Marketing Afiliados",
                            text: 'Auctor aliquam ut quam nibh consequat sociosqu senectus condimentum feugiat.',
                            button: {
                                text: "Learn more",
                                link: "#"
                            },
                            baIntelligenceTag: 'fc-c8-top-affiliate-training'
                        }
                    ]
                }
            },
            content9: {
                topper: {},
                category: {
                    title: "CATEGORY",
                    items: [
                        { /* item1 */
                            mainSvg: '/internacional/public/office4/img/onboarding-funnel/content-5/ic-training-card.svg',
                            title: "Marketing Afiliados",
                            text: 'Auctor aliquam ut quam nibh consequat sociosqu senectus condimentum feugiat.',
                            button: {
                                text: "Learn more",
                                link: "#"
                            },
                            baIntelligenceTag: 'fc-c9-quick-start-training'
                        }
                    ]
                }
            },
            content10: {
                title: 'New Funnels of The Month',
                slides: [
                {
                    link: '#',
                    baIntelligenceTag: 'fc-c10-new-funnel-of-month-us-x-y',
                    thumb: {
                        img: '/internacional/public/office4/img/onboarding-funnel/content-3/example_thumb.png',
                        text: 'Show Funnel'
                    },
                    title: 'Chat Bot Funnel',
                    subtitle: "PFF004 EN - Weight Loss Detox",
                    button: {
                        label: 'Download',
                        link: '#',
                        baIntelligenceTag: 'fc-c10-download-new-funnel-of-month-us-x-y'
                    }
                },
                {
                    link: '#',
                    baIntelligenceTag: 'fc-c10-new-funnel-of-month-us-x-y',
                    thumb: {
                        img: '/internacional/public/office4/img/onboarding-funnel/content-3/example_thumb.png',
                        text: 'Show Funnel'
                    },
                    title: 'Chat Bot Funnel',
                    subtitle: "PFF004 EN - Weight Loss Detox",
                    button: null
                },
                {
                    link: '#',
                    baIntelligenceTag: 'fc-c10-new-funnel-of-month-us-x-y',
                    thumb: {
                        img: '/internacional/public/office4/img/onboarding-funnel/content-3/example_thumb.png',
                        text: 'Show Funnel'
                    },
                    title: 'Chat Bot Funnel',
                    subtitle: "PFF004 EN - Weight Loss Detox",
                    button: null
                },
                {
                    link: '#',
                    baIntelligenceTag: 'fc-c10-new-funnel-of-month-us-x-y',
                    thumb: {
                        img: '/internacional/public/office4/img/onboarding-funnel/content-3/example_thumb.png',
                        text: 'Show Funnel'
                    },
                    title: 'Chat Bot Funnel',
                    subtitle: "PFF004 EN - Weight Loss Detox",
                    button: null
                },
                {
                    link: '#',
                    baIntelligenceTag: 'fc-c10-new-funnel-of-month-us-x-y',
                    thumb: {
                        img: '/internacional/public/office4/img/onboarding-funnel/content-3/example_thumb.png',
                        text: 'Show Funnel'
                    },
                    title: 'Chat Bot Funnel',
                    subtitle: "PFF004 EN - Weight Loss Detox",
                    button: null
                },
                {
                    link: '#',
                    baIntelligenceTag: 'fc-c10-new-funnel-of-month-us-x-y',
                    thumb: {
                        img: '/internacional/public/office4/img/onboarding-funnel/content-3/example_thumb.png',
                        text: 'Show Funnel'
                    },
                    title: 'Chat Bot Funnel',
                    subtitle: "PFF004 EN - Weight Loss Detox",
                    button: null
                },
                {
                    link: '#',
                    baIntelligenceTag: 'fc-c10-new-funnel-of-month-us-x-y',
                    thumb: {
                        img: '/internacional/public/office4/img/onboarding-funnel/content-3/example_thumb.png',
                        text: 'Show Funnel'
                    },
                    title: 'Chat Bot Funnel',
                    subtitle: "PFF004 EN - Weight Loss Detox",
                    button: null
                },
                {
                    link: '#',
                    baIntelligenceTag: 'fc-c10-new-funnel-of-month-us-x-y',
                    thumb: {
                        img: '/internacional/public/office4/img/onboarding-funnel/content-3/example_thumb.png',
                        text: 'Show Funnel'
                    },
                    title: 'Chat Bot Funnel',
                    subtitle: "PFF004 EN - Weight Loss Detox",
                    button: null
                },
                {
                    link: '#',
                    baIntelligenceTag: 'fc-c10-new-funnel-of-month-us-x-y',
                    thumb: {
                        img: '/internacional/public/office4/img/onboarding-funnel/content-3/example_thumb.png',
                        text: 'Show Funnel'
                    },
                    title: 'Chat Bot Funnel',
                    subtitle: "PFF004 EN - Weight Loss Detox",
                    button: null
                },
                {
                    link: '#',
                    baIntelligenceTag: 'fc-c10-new-funnel-of-month-us-x-y',
                    thumb: {
                        img: '/internacional/public/office4/img/onboarding-funnel/content-3/example_thumb.png',
                        text: 'Show Funnel'
                    },
                    title: 'Chat Bot Funnel',
                    subtitle: "PFF004 EN - Weight Loss Detox",
                    button: null
                },
                {
                    link: '#',
                    baIntelligenceTag: 'fc-c10-new-funnel-of-month-us-x-y',
                    thumb: {
                        img: '/internacional/public/office4/img/onboarding-funnel/content-3/example_thumb.png',
                        text: 'Show Funnel'
                    },
                    title: 'Chat Bot Funnel',
                    subtitle: "PFF004 EN - Weight Loss Detox",
                    button: null
                },
                {
                    link: '#',
                    baIntelligenceTag: 'fc-c10-new-funnel-of-month-us-x-y',
                    thumb: {
                        img: '/internacional/public/office4/img/onboarding-funnel/content-3/example_thumb.png',
                        text: 'Show Funnel'
                    },
                    title: 'Chat Bot Funnel',
                    subtitle: "PFF004 EN - Weight Loss Detox",
                    button: null
                }
                ]
            },
        }
    },
    methods: {
        getButton(linkBtn) {
            return {
                'text': this.view.translation.general.learn_more,
                'link': linkBtn
            }
        },
        getRawObject(obj) {
            return JSON.parse(JSON.stringify(obj))
        },
    },
    computed: {
        ofPage: function () {
            if (this.view !== undefined && this.view !== null) {
                return {
                    content1: this.translatedContent1,
                    content2: this.translatedContent2,
                    content3: this.translatedContent3,
                    content4: this.translatedContent4,
                    content5: this.translatedContent5,
                    content6: this.translatedContent6, /* */
                    content7: this.translatedContent7,
                    content8: this.translatedContent8,
                    content9: this.translatedContent9,
                    content10: this.translatedContent10
                }
            } else {
                return this.$data
            }
        },
        translatedContent1: function() {
            let c1 = Object.assign({}, this.getRawObject(this.content1))


            if (this.view !== undefined && this.view !== null) {
                c1 = lodash.merge(c1, this.getRawObject(this.view.translation.content1 ) );
                /* conferir ao final socialMedia */
                c1.tutorial.button = this.getButton(this.view.translation.content1.tutorial.button);
                c1.socialMedia.url_socials = this.getRawObject( this.view.url_socials );
            }
            return c1;
        },
        translatedContent2: function() {
            let c2 = Object.assign({}, this.getRawObject(this.content2))


            if (this.view !== undefined && this.view !== null) {
                c2 = lodash.merge(c2, this.getRawObject( this.view.translation.content2 ) );
            }
            return c2;
        },
        translatedContent3: function() {
            let c3 = Object.assign({}, this.getRawObject(this.content3))

            if (this.view !== undefined && this.view !== null) {
                /* card 1 */
                c3 = Object.assign({}, this.getRawObject(this.view.translation.content3))
            }
            return c3;
        },
        translatedContent4: function() {
            let c4 = Object.assign({}, this.getRawObject(this.content4))


            if (this.view !== undefined && this.view !== null) {
                c4.topper = lodash.merge(c4.topper, this.getRawObject(this.view.translation.content4.topper ) )

                for(let i = 0; i < c4.trainings.length; i++) {
                    c4.trainings[i] = lodash.merge(c4.trainings[i], this.getRawObject(this.view.translation.content4.trainings[i] ) );
                }
            }
            return c4;
        },
        translatedContent5: function() {
            let c5 = Object.assign({}, this.getRawObject(this.content5))


            if (this.view !== undefined && this.view !== null) {
                c5.topper = lodash.merge(c5.topper, this.getRawObject(this.view.translation.content5.topper ) );

                c5.category.title = this.view.translation.content5.category.title

                for( let i = 0; i < c5.category.items.length; i++) {
                    c5.category.items[i] = lodash.merge(c5.category.items[i], this.getRawObject(this.view.translation.content5.category['item'+(i+1)] ) )
                    c5.category.items[i].button = this.getButton( this.view.translation.content5.category['item'+(i+1)].button );
                }
            }
            return c5;
        },
        translatedContent6: function() {
            /* por enquanto sem traducao quando for definido
                como dinamizar a rota sera adequado
            */
            return this.content6;
        },
        translatedContent7: function() {
            let c7 = Object.assign({}, this.getRawObject(this.content7))


            if (this.view !== undefined && this.view !== null) {

                c7.title = this.view.translation.content7.title

                for( let i = 0; i < c7.items.length; i++) {
                    c7.items[i] = lodash.merge(c7.items[i], this.getRawObject(this.view.translation.content7['item'+(i+1)] ) )
                    c7.items[i].button = this.getButton( this.view.translation.content7['item'+(i+1)].button );
                }
            }
            return c7;
        },

        translatedContent8: function() {
            let c8 = Object.assign({}, this.getRawObject(this.content8))


            if (this.view !== undefined && this.view !== null) {

                c8.category.title = this.view.translation.content8.category.title

                for( let i = 0; i < c8.category.items.length; i++) {
                    c8.category.items[i] = lodash.merge(c8.category.items[i], this.getRawObject(this.view.translation.content8.category['item'+(i+1)] ) )
                    c8.category.items[i].button = this.getButton( this.view.translation.content8.category['item'+(i+1)].button );
                }
            }
            return c8;
        },
        translatedContent9: function() {
            let c9 = Object.assign({}, this.getRawObject(this.content9))


            if (this.view !== undefined && this.view !== null) {

                c9.category.title = this.view.translation.content9.category.title

                for( let i = 0; i < c9.category.items.length; i++) {
                    c9.category.items[i] = lodash.merge(c9.category.items[i], this.getRawObject(this.view.translation.content9.category['item'+(i+1)] ) )
                    c9.category.items[i].button = this.getButton( this.view.translation.content9.category['item'+(i+1)].button );
                }
            }
            return c9;
        },
        translatedContent10: function() {
            let c10 = Object.assign({}, this.getRawObject(this.content10))

            if (this.view !== undefined && this.view !== null) {
                /* card 1 */
                c10 = Object.assign({}, this.getRawObject(this.view.translation.content10))
            }
            return c10;
        },
    },
    created() {
    },
    mounted() {
        console.log(this.view)
    }
};
</script>
<!-- GLOBAL SCSS -->
<style lang="scss">
    @import "../../../../scss/office";
    #content{
        padding: 0!important;
    }
    #main{
        background-color: $of-color19!important;
    }
</style>
<!-- SCOPED SCSS -->
<style scoped lang="scss">
    @import "../../../../scss/office";

    /* fonte Mulish, em outras partes do sistema foi importado so localmente*/
    @import url("https://fonts.googleapis.com/css2?family=Mulish:wght@400;500;600;700&display=swap");

    .of-container{
        text-align: center;
        font-family: $of-font2;
        font-size: 10px;
        padding: 4.3em 0; /* 43px */
        .of-content {
            margin: 0 auto;
            width: 90%;
            max-width: 1220px;
            font-family: 2.6em;
        }
    }

    @media (max-width: 768px) { /* smartphones */
        .of-container{
            font-size: 6px;
        }
    }
    @media (min-width: 769px) and (max-width: 1365px) { /* tablets */
        .of-container{
            font-size: 7.5px;
        }
    }
    @media (min-width: 1366px) { /* large devices */
        .of-container{
            font-size: 10px;
        }
    }
</style>



// WEBPACK FOOTER //
// resources/office/js/components/dashboard/onboardingFunnel/index.vue